export const ExternalLinkImportStates = {
  UPLOADING_FILES: 'uploading_files',
  PROCESSING: 'processing',
  DONE_SUCCESS: 'done_success',
  DONE_ERROR: 'done_error',
};
